<template>
  <div>
    <h2 class="subtitle has-text-centered">
      {{ approvedTransactions.length }} {{ $t("transactions.approved") }} -
      <b-tooltip multilined label="Fat. Bruto / Qtd. Vendas Aprovadas">
        {{ `${$t("transactions.averageTicket")} ${payments.currencySymbol}` }}
        {{
          formatMoney(
            approvedTransactions.length
              ? grossSales / approvedTransactions.length
              : 0
          )
        }}
      </b-tooltip>
    </h2>

    <div class="columns has-text-centered is-mobile is-multiline">
      <summary-card
        :tooltipText="$t('transactions.grossSalesDescription')"
        :text="$t('transactions.grossSales')"
        :value="grossSales"
      />

      <summary-card
        :tooltipText="$t('transactions.discountsDescription')"
        :text="$t('transactions.discounts')"
        :value="discounts"
      />

      <summary-card
        :tooltipText="$t('transactions.netSalesDescription')"
        :text="$t('transactions.netSales')"
        :value="netSales"
      />

      <summary-card
        :tooltipText="$t('transactions.royaltiesDescription')"
        :text="$t('transactions.royalties')"
        :value="royalties"
        v-show="!onlyCacauShowVendings"
      />

      <summary-card
        :tooltipText="$t('transactions.receivableDescription')"
        :text="$t('transactions.receivable')"
        :value="receivable"
        v-show="!onlyCacauShowVendings"
      />

      <summary-card
        :tooltipText="$t('transactions.cogsDescription')"
        :text="$t('transactions.cogs')"
        :value="cogs"
        :percentage="((cogs / grossSales) * 100).toFixed(2)"
        v-show="!onlyCacauShowVendings"
      />

      <summary-card
        :tooltipText="$t('transactions.marginDescription')"
        :text="$t('transactions.margin')"
        :value="margin"
        :percentage="((margin / grossSales) * 100).toFixed(2)"
        v-show="!onlyCacauShowVendings"
      />
    </div>

    <div class="columns has-text-centered is-mobile is-multiline">
      <!-- A faturar -->
      <summary-card
        v-if="buyNowPayLaterValue > 0"
        :cards="[
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: $t('transactions.buyNowPayLater'),
            value: buyNowPayLaterValue,
            percentage: buyNowPayLaterPercentage
          }
        ]"
        bigCard
      />

      <!-- PIX: PREPAGO E PIX -->
      <summary-card
        :cards="[
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: $t('transactions.pixAndPrepaid'),
            value: pixAndPrepaidValue,
            percentage: pixAndPrepaidPercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: $t('transactions.pix'),
            value: pixValue,
            percentage: pixValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: $t('transactions.prepaid'),
            value: appPrepaidValue,
            percentage: appPrepaidValuePercentage
          }
        ]"
        bigCard
      />

      <!-- VOUCHER: SODEXO, ALELO, TICKET, VR, VEROCARD, BEN -->
      <summary-card
        :cards="[
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: $t('transactions.voucher'),
            value: voucherValue,
            percentage: voucherValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.sodexo')}`,
            value: voucherSodexoValue,
            percentage: voucherSodexoValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.alelo')}`,
            value: voucherAleloValue,
            percentage: voucherAleloValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.ticket')}`,
            value: voucherTicketValue,
            percentage: voucherTicketValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.vr')}`,
            value: voucherVrValue,
            percentage: voucherVrValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.verocard')}`,
            value: voucherVerocardValue,
            percentage: voucherVerocardValuePercentage
          },
          {
            tooltipText: $t('transactions.relativeToNetSales'),
            text: `${$t('transactions.ben')}`,
            value: voucherBenValue,
            percentage: voucherBenValuePercentage
          }
        ]"
        bigCard
      />

      <!-- CREDIT: TERMINAL, APP, GOOGLEPAY, APPLEPAY -->
      <summary-card
        :cards="
          tefCreditValue > 0
            ? [
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.credit'),
                  value: creditTotalValue,
                  percentage: creditTotalPercentage
                },
                // {
                //   tooltipText: $t('transactions.relativeToNetSales'),
                //   text: $t('transactions.tefCredit'),
                //   value: tefCreditValue,
                //   percentage: tefCreditValuePercentage,
                // },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.terminalCredit'),
                  value: terminalCreditValue,
                  percentage: terminalCreditValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.appCreditAdyen'),
                  value: appCreditAdyenValue,
                  percentage: appCreditAdyenValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.googlepay')} ${$t(
                    'transactions.credit'
                  )} `,
                  value: googlePayCreditValue,
                  percentage: googlePayCreditPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.applepay')} ${$t(
                    'transactions.credit'
                  )} `,
                  value: applePayCreditValue,
                  percentage: applePayCreditValuePercentage
                }
              ]
            : [
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.credit'),
                  value: creditTotalValue,
                  percentage: creditTotalPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.terminalCredit'),
                  value: terminalCreditValue,
                  percentage: terminalCreditValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.appCreditAdyen'),
                  value: appCreditAdyenValue,
                  percentage: appCreditAdyenValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.googlepay')} ${$t(
                    'transactions.credit'
                  )} `,
                  value: googlePayCreditValue,
                  percentage: googlePayCreditPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.applepay')} ${$t(
                    'transactions.credit'
                  )} `,
                  value: applePayCreditValue,
                  percentage: applePayCreditValuePercentage
                }
              ]
        "
        bigCard
      />

      <!-- DEBIT: TERMINAL, GOOGLEPAY, APPLEPAY -->
      <summary-card
        :cards="
          tefDebitValue > 0
            ? [
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.debit'),
                  value: debitTotalValue,
                  percentage: debitTotalPercentage
                },
                // {
                //   tooltipText: $t('transactions.relativeToNetSales'),
                //   text: $t('transactions.tefDebit'),
                //   value: tefDebitValue,
                //   percentage: tefDebitValuePercentage,
                // },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.terminalDebit'),
                  value: terminalDebitValue,
                  percentage: terminalDebitValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.googlepay')} ${$t(
                    'transactions.debit'
                  )}`,
                  value: googlePayDebitValue,
                  percentage: googlePayDebitPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.applepay')} ${$t(
                    'transactions.debit'
                  )}`,
                  value: applePayDebitValue,
                  percentage: applePayDebitValuePercentage
                }
              ]
            : [
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.debit'),
                  value: debitTotalValue,
                  percentage: debitTotalPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: $t('transactions.terminalDebit'),
                  value: terminalDebitValue,
                  percentage: terminalDebitValuePercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.googlepay')} ${$t(
                    'transactions.debit'
                  )}`,
                  value: googlePayDebitValue,
                  percentage: googlePayDebitPercentage
                },
                {
                  tooltipText: $t('transactions.relativeToNetSales'),
                  text: `${$t('transactions.applepay')} ${$t(
                    'transactions.debit'
                  )}`,
                  value: applePayDebitValue,
                  percentage: applePayDebitValuePercentage
                }
              ]
        "
        bigCard
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../../mixins/mask";
import summaryCard from "./SummaryCard";

export default {
  props: ["transactions"],

  mixins: [mask],

  components: {
    summaryCard
  },

  computed: {
    ...mapGetters(["payments", "onlyCacauShowVendings"]),

    // summary cards
    approvedTransactions() {
      return this.transactions.filter(t => {
        return (
          t.details.status === "success" ||
          t.details.format === "buyNowPayLater"
        );
      });
    },

    grossSales() {
      return this.approvedTransactions.length
        ? this.approvedTransactions.reduce((grossSales, t) => {
            return (grossSales += t.cart.totalValue);
          }, 0)
        : 0;
    },

    discounts() {
      return this.approvedTransactions.length
        ? this.approvedTransactions.reduce((discounts, t) => {
            const cashbackUsed =
              t.discounts && t.discounts.cashbackUsed
                ? t.discounts.cashbackUsed
                : 0;
            const couponTotal =
              t.discounts && t.discounts.coupon && t.discounts.coupon.total
                ? t.discounts.coupon.total
                : 0;

            return discounts + cashbackUsed + couponTotal;
          }, 0)
        : 0;
    },

    netSales() {
      return this.grossSales - this.discounts;
    },

    royalties() {
      return this.approvedTransactions.length
        ? this.approvedTransactions
            .filter(t => t.details.format !== "tef")
            .reduce((royalties, t) => {
              return t.details.royaltyValue === 0
                ? (royalties += t.details.chargedValue * 0.1 || 0)
                : (royalties += t.details.royaltyValue || 0);
            }, 0) +
            this.approvedTransactions
              .filter(t => t.details.format === "tef")
              .reduce((royalties, t) => {
                return (royalties += t.details.royaltyValue || 0);
              }, 0)
        : 0;
    },

    receivable() {
      return this.netSales - this.royalties;
    },

    cogs() {
      let cogs = 0;
      if (this.approvedTransactions.length) {
        cogs = this.approvedTransactions.reduce((cogs, t) => {
          return (
            cogs +
            t.cart.items.reduce((itemCogs, item) => {
              return itemCogs + (item.lastCost || 0) * item.quantity;
            }, 0)
          );
        }, 0);
      }
      return cogs;
    },

    margin() {
      return this.receivable - this.cogs;
    },

    // prepaid
    appPrepaid() {
      return this.approvedTransactions.filter(t => {
        return t.details.prepaid > 0;
      });
    },

    appPrepaidValue() {
      return this.appPrepaid.length
        ? this.appPrepaid.reduce((r, t) => {
            return r + (t.details.prepaid || 0);
          }, 0)
        : 0;
    },

    appPrepaidValuePercentage() {
      return this.netSales
        ? ((this.appPrepaidValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // buy now pay later
    buyNowPayLater() {
      return this.approvedTransactions.filter(t => {
        return t.details.format === "buyNowPayLater";
      });
    },

    buyNowPayLaterValue() {
      return this.buyNowPayLater.length
        ? this.buyNowPayLater.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    buyNowPayLaterPercentage() {
      return this.netSales
        ? ((this.buyNowPayLaterValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // pix
    pix() {
      return this.approvedTransactions.filter(t => {
        return t.details.fundingSource === "pix";
      });
    },

    pixValue() {
      return this.pix.length
        ? this.pix.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    pixValuePercentage() {
      return this.netSales
        ? ((this.pixValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // money
    money() {
      return this.approvedTransactions.filter(t => {
        return t.details.fundingSource === "money";
      });
    },

    moneyValue() {
      return this.money.length
        ? this.money.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    moneyPercentage() {
      return this.netSales
        ? ((this.moneyValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // app credit adyen
    appCreditAdyen() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.provider === "adyen" &&
          t.details.format === "ecommerce" &&
          t.details.fundingSource === "credit"
        );
      });
    },

    appCreditAdyenValue() {
      return this.appCreditAdyen.length
        ? this.appCreditAdyen.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    appCreditAdyenValuePercentage() {
      return this.netSales
        ? ((this.appCreditAdyenValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // terminal credit adyen
    terminalCredit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "credit" &&
          t.details.format === "terminal" &&
          t.details.provider === "adyen"
        );
      });
    },

    terminalCreditValue() {
      return this.terminalCredit.length
        ? this.terminalCredit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    terminalCreditValuePercentage() {
      return this.netSales
        ? ((this.terminalCreditValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // terminal debit adyen
    terminalDebit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "debit" &&
          t.details.format === "terminal" &&
          t.details.provider === "adyen"
        );
      });
    },

    terminalDebitValue() {
      return this.terminalDebit.length
        ? this.terminalDebit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    terminalDebitValuePercentage() {
      return this.netSales
        ? ((this.terminalDebitValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // tef credit
    tefCredit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "credit" && t.details.format === "tef"
        );
      });
    },

    tefCreditValue() {
      return this.tefCredit.length
        ? this.tefCredit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    tefCreditValuePercentage() {
      return this.netSales
        ? ((this.tefCreditValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // tef debit
    tefDebit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "debit" && t.details.format === "tef"
        );
      });
    },

    tefDebitValue() {
      return this.tefDebit.length
        ? this.tefDebit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    tefDebitValuePercentage() {
      return this.netSales
        ? ((this.tefDebitValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher
    voucher() {
      return this.approvedTransactions.filter(t => {
        return t.details.fundingSource === "voucher";
      });
    },

    voucherValue() {
      return this.voucher.length
        ? this.voucher.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherValuePercentage() {
      return this.netSales
        ? ((this.voucherValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher sodexo
    voucherSodexo() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "sodexo"
        );
      });
    },

    voucherSodexoValue() {
      return this.voucherSodexo.length
        ? this.voucherSodexo.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherSodexoValuePercentage() {
      return this.netSales
        ? ((this.voucherSodexoValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher alelo
    voucherAlelo() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "alelo"
        );
      });
    },

    voucherAleloValue() {
      return this.voucherAlelo.length
        ? this.voucherAlelo.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherAleloValuePercentage() {
      return this.netSales
        ? ((this.voucherAleloValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher ticket
    voucherTicket() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "ticket"
        );
      });
    },

    voucherTicketValue() {
      return this.voucherTicket.length
        ? this.voucherTicket.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherTicketValuePercentage() {
      return this.netSales
        ? ((this.voucherTicketValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher vr
    voucherVr() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "vr"
        );
      });
    },

    voucherVrValue() {
      return this.voucherVr.length
        ? this.voucherVr.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherVrValuePercentage() {
      return this.netSales
        ? ((this.voucherVrValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher verocard
    voucherVerocard() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "verocard"
        );
      });
    },

    voucherVerocardValue() {
      return this.voucherVerocard.length
        ? this.voucherVerocard.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherVerocardValuePercentage() {
      return this.netSales
        ? ((this.voucherVerocardValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // voucher ben
    voucherBen() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.fundingSource === "voucher" &&
          t.details.paymentMethod === "ben"
        );
      });
    },

    voucherBenValue() {
      return this.voucherBen.length
        ? this.voucherBen.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    voucherBenValuePercentage() {
      return this.netSales
        ? ((this.voucherBenValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // google pay (credit + debit)
    googlePay() {
      return this.approvedTransactions.filter(t => {
        return t.details.format === "googlepay";
      });
    },

    googlePayValue() {
      return this.googlePay.length
        ? this.googlePay.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    googlePayValuePercentage() {
      return this.netSales
        ? ((this.googlePayValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // apple pay (credit + debit)
    applePay() {
      return this.approvedTransactions.filter(t => {
        return t.details.format === "applepay";
      });
    },

    applePayValue() {
      return this.applePay.length
        ? this.applePay.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    applePayValuePercentage() {
      return this.netSales
        ? ((this.applePayValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // pix + prepaid
    pixAndPrepaidValue() {
      return (this.pixValue || 0) + (this.appPrepaidValue || 0);
    },

    pixAndPrepaidPercentage() {
      return this.netSales
        ? ((this.pixAndPrepaidValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // google pay debit
    googlePayDebit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.format === "googlepay" &&
          t.details.fundingSource === "debit"
        );
      });
    },

    googlePayDebitValue() {
      return this.googlePayDebit.length
        ? this.googlePayDebit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    googlePayDebitPercentage() {
      return this.netSales
        ? ((this.googlePayDebitValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // google pay credit
    googlePayCredit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.format === "googlepay" &&
          t.details.fundingSource === "credit"
        );
      });
    },

    googlePayCreditValue() {
      return this.googlePayCredit.length
        ? this.googlePayCredit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    googlePayCreditPercentage() {
      return this.netSales
        ? ((this.googlePayCreditValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // apple pay debit
    applePayDebit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.format === "applepay" && t.details.fundingSource === "debit"
        );
      });
    },

    applePayDebitValue() {
      return this.applePayDebit.length
        ? this.applePayDebit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    applePayDebitValuePercentage() {
      return this.netSales
        ? ((this.applePayDebitValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // apple pay credit
    applePayCredit() {
      return this.approvedTransactions.filter(t => {
        return (
          t.details.format === "applepay" &&
          t.details.fundingSource === "credit"
        );
      });
    },

    applePayCreditValue() {
      return this.applePayCredit.length
        ? this.applePayCredit.reduce((r, t) => {
            return r + (t.details.paymentMethodValue || 0);
          }, 0)
        : 0;
    },

    applePayCreditValuePercentage() {
      return this.netSales
        ? ((this.applePayCreditValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // credit total
    creditTotalValue() {
      return (
        (this.terminalCreditValue || 0) +
        (this.tefCreditValue || 0) +
        (this.appCreditAdyenValue || 0) +
        (this.googlePayCreditValue || 0) +
        (this.applePayCreditValue || 0)
      );
    },

    creditTotalPercentage() {
      return this.netSales
        ? ((this.creditTotalValue / this.netSales) * 100).toFixed(2)
        : 0;
    },

    // debit total
    debitTotalValue() {
      return (
        (this.terminalDebitValue || 0) +
        (this.tefDebitValue || 0) +
        (this.googlePayDebitValue || 0) +
        (this.applePayDebitValue || 0)
      );
    },

    debitTotalPercentage() {
      return this.netSales
        ? ((this.debitTotalValue / this.netSales) * 100).toFixed(2)
        : 0;
    }
  }
};
</script>

<style scoped>
.columns {
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
}
</style>
